import { Injectable } from '@angular/core';
// import  jsPDF from 'jspdf';
@Injectable()
export class ExportService {
  [x: string]: any;
  arrayBuffer: any;
  file: File;
  constructor() {
  }

  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  
  preFormatLoanInfo(data) {
    let cp = Object.assign([], data);
    cp = JSON.stringify(cp);
    return JSON.parse(cp);
  }
  saveAsPdf(jsonData, infoData = { fileName: "fichierpdf", userName: "inconnue" }, critereRecherche?) {
    if (critereRecherche) {
      let rows = [];
      let col = [];
      for (var index in jsonData) {
        if (Number(index) == 0) {
          col.push(Object.keys(jsonData[index]));
        }
        var resultArray = Object.keys(jsonData[index]).map(function (element) {
          let objArray = jsonData[index][element];
          return objArray;
        });
        rows.push(resultArray);
      }
      let pdfOptions = {
        orientation: 'l',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts: true,
        precision: 2
      }
      let headStyle = {
        fillColor: [145, 87, 30],
        fontSize: 12
      }
      let doc;
      // new jsPDF(pdfOptions)
      let width = doc.internal.pageSize.getWidth();
      let height = doc.internal.pageSize.getHeight();
      const finalY = doc.previousAutoTable.finalY;
      let today = new Date().getDay() + "/" + new Date().getMonth() + "/" + new Date().getFullYear();
      // addImage(imageData, format, x, y, width, height, alias, compression, rotation)
      doc.addImage(this.getBase64Image(), "png", 10, 10, 60, 12, 'logo', 'FAST', 0);
      //Title du tableau
      doc.text("Critere de recherche", width / 3, 30);
      doc.text(infoData.fileName, width / 3, 57);
      doc.setFont("times");
      doc.setFontType("italic");
      doc.setFontSize(12);
      // doc.text(infoData.fileName+" "+today,200,14);
      doc.text("Prénom Souscripteur: " + critereRecherche.souscription.prenom, 15, 37);
      doc.text("Nom Souscripteur: " + critereRecherche.souscription.nom, 100, 37);
      doc.text("Prénom Assuré: " + critereRecherche.assure.prenom, 190, 37);
      doc.text("Nom Assuré: " + critereRecherche.assure.nom, 15, 44);
      doc.text("Prénom Bénéficiaire: " + critereRecherche.beneficaire.prenom, 100, 44);
      doc.text("Nom Bénéficiaire: " + critereRecherche.beneficaire.nom, 190, 44);
      doc.text("Durée: " + critereRecherche.duree.displayMe, 15, 51);
      doc.text("Prix: " + critereRecherche.duree.price, 15, 51);
      doc.autoTable(
        {
          head: col,
          body: rows,
          margin: { top: 61 },
          headStyles: headStyle,
          showHead: 'firstPage',
          rowPageBreak: 'avoid'
        });
      doc.setFont("times");
      doc.setFontType("italic");
      doc.setFontSize(10);
      doc.text(infoData.fileName + " du " + today, width - 120, 15);
      //pied de page  
      let colF = [[infoData.fileName, "généré par " + infoData.userName, "le " + today]];
      var rowsF = [];
      doc.autoTable({
        head: colF,
        body: rowsF,
        startY: height - 28.1,
        headStyles: { fillColor: [140, 80, 30], fontSize: 8 },
        pageBreak: 'avoid',
        margin: { horizontal: 20 },
        bodyStyles: { valign: 'top' },
        styles: { overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: { cellWidth: 'auto' }
      });
      //Sauvegarde pdf
      doc.save(infoData.fileName + '_' + new Date().toISOString() + '.pdf');
    } else {
      this.saveAsPdfTableOnly(jsonData, infoData);
    }
  }
  saveAsPdfTableOnly(jsonData, infoData = { fileName: "fichierpdf", userName: "inconnue" }) {
    let rows = [];
    let col = [];
    for (var index in jsonData) {
      if (Number(index) == 0) {
        col.push(Object.keys(jsonData[index]));
      }
      var resultArray = Object.keys(jsonData[index]).map(function (element) {
        let objArray = jsonData[index][element];
        return objArray;
      });
      rows.push(resultArray);
    }
    let pdfOptions = {
      orientation: 'l',
      unit: 'mm',
      format: 'a4',
      putOnlyUsedFonts: true,
      precision: 2
    }
    let headStyle = {
      fillColor: [145, 87, 30],
      fontSize: 12
    }
    let doc;
    // new jsPDF(pdfOptions)
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();
    const finalY = doc.previousAutoTable.finalY;
    let today = new Date().getDay() + "/" + new Date().getMonth() + "/" + new Date().getFullYear();
    // addImage(imageData, format, x, y, width, height, alias, compression, rotation)
    doc.addImage(this.getBase64Image(), "png", 10, 10, 60, 12, 'logo', 'FAST', 0);
    // doc.text(infoData.fileName+" "+today,200,14);
    //Title du tableau
    doc.text(infoData.fileName, width / 3, 30);
    doc.autoTable(
      {
        head: col,
        body: rows,
        margin: { top: 32 },
        headStyles: headStyle,
        showHead: 'firstPage',
        rowPageBreak: 'avoid'
      });
    doc.setFont("times");
    doc.setFontType("italic");
    doc.setFontSize(10);
    doc.text(infoData.fileName + " du " + today, width - 100, 15);
    //pied de page  
    let colF = [[infoData.fileName, "généré par " + infoData.userName, "le " + today]];
    var rowsF = [];
    doc.autoTable({
      head: colF,
      body: rowsF,
      startY: height - 28,
      headStyles: { fillColor: [0, 0, 0], fontSize: 8 },
      pageBreak: 'avoid',
      margin: { horizontal: 7 },
      bodyStyles: { valign: 'top' },
      styles: { overflow: 'linebreak', cellWidth: 'wrap' },
      columnStyles: { cellWidth: 'auto' }
    });
    //Sauvegarde pdf
    doc.save(infoData.fileName + '_' + new Date().getTime() + '.pdf');
  }
 
  getBase64Image() {
    var img = new Image(); //  Constructeur HTML5
    img.src = 'assets/img/logo.svg';
    // We create a HTML canvas object that will create a 2d image
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");   // This will draw image    
    ctx.drawImage(img, 0, 0);
    // Convert the drawn image to Data URL
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }
}